import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
export const PanoramaLayout = (props)=>{
    const { imageUrl } = props;
    return /*#__PURE__*/ _jsx("section", {
        className: "block block--content-grid container--mg align--center",
        children: /*#__PURE__*/ _jsx("div", {
            className: "block__visual container--s align--center",
            children: /*#__PURE__*/ _jsx(ReactPhotoSphereViewer, {
                src: imageUrl,
                height: "524",
                width: "100%",
                containerClass: "block block--content-grid align--center"
            })
        })
    });
};
